import { useAuth } from "@clerk/nextjs";

import ChatHistoryItem from "./ChatHistoryItem";
import useThreads from "~/hooks/useThreads";

interface ChatHistoryProps {
	onSelectThread: (threadId: number) => void;
}

const ChatHistory = ({ onSelectThread }: ChatHistoryProps) => {
	const { isSignedIn } = useAuth();
	const { threads, hasMore, loadMore, isLoading, isLoadingMore } = useThreads(
		!!isSignedIn,
	);

	if (isLoading) {
		return (
			<div className="flex flex-1 items-center justify-center text-slate-400 text-sm">
				Loading…
			</div>
		);
	}

	if (threads.length === 0) {
		return (
			<div className="flex flex-1 flex-col items-center justify-center gap-1 px-6 text-center">
				<p className="font-medium text-slate-500 text-sm dark:text-slate-400">
					No conversations yet
				</p>
				<p className="text-slate-400 text-xs dark:text-slate-500">
					Start a new chat to see it here.
				</p>
			</div>
		);
	}

	return (
		<div className="flex flex-1 flex-col gap-0.5 overflow-y-auto p-2">
			{threads.map((thread) => (
				<ChatHistoryItem
					key={thread.id}
					thread={thread}
					onSelect={() => onSelectThread(thread.id)}
				/>
			))}
			{hasMore && (
				<div className="flex justify-center px-4 py-3">
					<button
						type="button"
						onClick={loadMore}
						disabled={isLoadingMore}
						className="rounded-full px-3 py-1.5 font-medium text-sky-600 text-sm transition-colors hover:bg-sky-50 disabled:opacity-50 dark:text-sky-400 dark:hover:bg-sky-500/10"
					>
						{isLoadingMore ? "Loading…" : "Load more"}
					</button>
				</div>
			)}
		</div>
	);
};

export default ChatHistory;
